'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _profilesDataActions = require('actions/profilesDataActions');

var _utilityFunctions = require('utils/utilityFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// profiles resources are stored by id
function profiles() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _profilesDataActions.PROFILES_DATA_RECEIVED:
            return (0, _utilityFunctions.reduceResourceArrayToObjById)(action.newProfilesData, 'customer_id');
        case _profilesDataActions.PROFILES_UPDATE_SUCCEEDED:
            return (0, _extends3.default)({}, state, (0, _utilityFunctions.reduceResourceArrayToObjById)(action.updatedProfiles, 'customer_id'));
        default:
            return state;
    }
}

exports.default = profiles;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/profiles.js
// module id = 1401
// module chunks = 0